import { useContext } from 'react';
import { Trans } from '@lingui/macro';
import ReadMore from '@components/read-more';

import { addClickableLinks } from '@utils/Utils';
import { useIsMobile } from '@utils/hooks/useIsMobile';
import { BasicData } from '@App';

import './style.scss';

const About = () => {
    const { branding, contact_detail } = useContext(BasicData);

    const mobile = useIsMobile();

    return (
        <div className='about'>
            {contact_detail?.consultant_description ? (
                <>
                    <div className='about-consultant'>
                        <h3><Trans>About</Trans> {contact_detail?.consultant_name}</h3>
                        <div className="break-words" dangerouslySetInnerHTML={{ __html: contact_detail?.consultant_description }} />
                    </div>

                    {contact_detail?.countries_visited && 
                        <div className='about-countries-visited'>
                            <h4><Trans>Countries Visited</Trans></h4>
                            {mobile ?
                                <ReadMore header="Countries Visited" lines={10} maxHeightOverflow={210}>
                                    <div dangerouslySetInnerHTML={{ __html: contact_detail?.countries_visited }} />
                                </ReadMore>
                                :
                                <div className="break-words" dangerouslySetInnerHTML={{ __html: addClickableLinks(contact_detail?.countries_visited) }} />
                            }
                        </div>
                    }
                    {contact_detail?.favourite_destinations && 
                        <div className='about-favourite-destinations'>
                            <h4><Trans>Favourite Destinations</Trans></h4>
                            {mobile ?
                                <ReadMore header="Favourite Destinations" lines={10} maxHeightOverflow={210}>
                                    <div dangerouslySetInnerHTML={{ __html: contact_detail?.favourite_destinations }} />
                                </ReadMore>
                                :
                                <div className="break-words" dangerouslySetInnerHTML={{ __html: addClickableLinks(contact_detail?.favourite_destinations) }} />
                            }
                        </div>
                    }
                </>
            ) : contact_detail?.company_description && branding?.company_description !== contact_detail?.company_description ? (
                <div className='about-consultant'>
                    <h3><Trans>About</Trans> {contact_detail?.company_name}</h3>
                    <div className="break-words" dangerouslySetInnerHTML={{ __html: contact_detail?.company_description }} />
                </div>
            ) : ""}
            {branding?.company_description &&
                <div className='about-company'>
                    <h3><Trans>About</Trans> {branding?.company_name}</h3>
                    <div className="break-words" dangerouslySetInnerHTML={{ __html: branding?.company_description }} />
                </div>
            }
        </div>
    )
}

export default About;